import BackupSummary from '../../types/backup/BackupSummary';
import { CHAIN_STATUS_LABELS, chainTooltip } from './backupChainUtils';

const STATUS_CLASS_NAMES = {
    ok: 'bg-success',
    broken: 'bg-danger',
    unverified: 'bg-secondary',
    warning: 'bg-warning text-dark',
};

// Whether the database's backups can be restored in sequence, with the
// reason and the point-in-time restore window in the tooltip.
function BackupChainStatus({ row }: { row: BackupSummary }) {
    if (!row.chainstatus) {
        return <>-</>;
    }
    const tooltip = chainTooltip(row);
    return <span className={`badge ${STATUS_CLASS_NAMES[row.chainstatus]}`}
                 data-tooltip-id="global-tooltip" data-tooltip-content={tooltip || undefined}>
        {CHAIN_STATUS_LABELS[row.chainstatus]}
    </span>;
}

export default BackupChainStatus;
